import { Button, Flex, ModalV2 } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";

type ConfirmRestoreTemplateModalProps = {
  isOpen: boolean;
  isSystemTemplate: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isRestoring: boolean;
};

export const ConfirmRestoreTemplateModal = ({
  isOpen,
  isSystemTemplate,
  onClose,
  onConfirm,
  isRestoring,
}: ConfirmRestoreTemplateModalProps) => (
  <ModalV2
    show={isOpen}
    onHide={onClose}
    title="Restore template"
    description={
      isSystemTemplate
        ? "Restoring this template makes it available for users to view and duplicate. If the related data package is archived, it will be restored as well."
        : "All staff users will be able to run reports using this template. If the related data package is archived, it will be restored as well."
    }
    size="small"
    data-testid="confirm-restore-template-modal"
  >
    <ModalV2.Body>
      <Flex gap={SPACING.SMALL} justifyContent="flex-end">
        <Button variant="neutral" onClick={onClose} disabled={isRestoring}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={onConfirm}
          isLoading={isRestoring}
          disabled={isRestoring}
          data-testid="confirm-restore-template-button"
        >
          Restore template
        </Button>
      </Flex>
    </ModalV2.Body>
  </ModalV2>
);
